import LoginResult from "./LoginResult";
import Env from "./Env";
import { ApolloClient } from "@apollo/client";
import * as __d3ett from "../rocket/D3ETemplate";
import { D3ETemplate } from "../rocket/D3ETemplate";
import Hospitals from "./Hospitals";
import GraphQLClientInit from "../utils/GraphQLClientInit";
import LocalDataStore from "../utils/LocalDataStore";
import AdminListsRequest from "../models/AdminListsRequest";
import Invoices from "./Invoices";
import AdminLists from "./AdminLists";
import RequestsByInvoiceRequest from "../models/RequestsByInvoiceRequest";
import MessageDispatch from "../rocket/MessageDispatch";
import UsersList from "./UsersList";
import ActivityTrackersRequest from "../models/ActivityTrackersRequest";
import NotificationsRequest from "../models/NotificationsRequest";
import Administrator from "../models/Administrator";
import Invoice from "../models/Invoice";
import HosiptalList from "./HosiptalList";
import ActivityTrackers from "./ActivityTrackers";
import InvoicesRequest from "../models/InvoicesRequest";
import HospitalsRequest from "../models/HospitalsRequest";
import ActivityTracker from "../models/ActivityTracker";
import RequestsByInvoice from "./RequestsByInvoice";
import ReferenceCatch from "../utils/ReferenceCatch";
import NOKUser from "../models/NOKUser";
import SearchRequests from "./SearchRequests";
import SearchRequestsRequest from "../models/SearchRequestsRequest";
import Notification from "../models/Notification";
import UsersListRequest from "../models/UsersListRequest";
import SearchRequest from "../models/SearchRequest";
import Hospital from "../models/Hospital";
import BaseUser from "../models/BaseUser";
import Notifications from "./Notifications";

export default class Query {
  private _client: ApolloClient<any>;
  private static _queryObject: Query;
  private _referenceCatch: ReferenceCatch;
  private constructor() {}
  private static _init() {
    let q = new Query();

    q._client = GraphQLClientInit.get();

    q._referenceCatch = ReferenceCatch.get();

    return q;
  }
  public static get() {
    if (Query._queryObject == null) {
      Query._queryObject = Query._init();
    }

    return Query._queryObject;
  }
  public async currentUser(): Promise<BaseUser> {
    GraphQLClientInit.token = await LocalDataStore.get().getToken();

    return await LocalDataStore.get().currentUser();
  }
  public async logout(): Promise<boolean> {
    LocalDataStore.get().setUser(null, null);

    await MessageDispatch.get().logout();

    return true;
  }
  public async getAdministratorById(
    usage: number,
    id: number
  ): Promise<Administrator> {
    return MessageDispatch.get().query(__d3ett.ADMINISTRATOR, id, usage);
  }
  public async getHospitalById(usage: number, id: number): Promise<Hospital> {
    return MessageDispatch.get().query(__d3ett.HOSPITAL, id, usage);
  }
  public async getInvoiceById(usage: number, id: number): Promise<Invoice> {
    return MessageDispatch.get().query(__d3ett.INVOICE, id, usage);
  }
  public async getNOKUserById(usage: number, id: number): Promise<NOKUser> {
    return MessageDispatch.get().query(__d3ett.NOKUSER, id, usage);
  }
  public async getSearchRequestById(
    usage: number,
    id: number
  ): Promise<SearchRequest> {
    return MessageDispatch.get().query(__d3ett.SEARCHREQUEST, id, usage);
  }
  public async loginNOKUserUserWithEmailAndPassword(
    usage: number,
    d3eParams?: Partial<{
      email: string;
      password: string;
      deviceToken: string;
    }>
  ): Promise<LoginResult> {
    let email = d3eParams?.email;

    let password = d3eParams?.password;

    let deviceToken = d3eParams?.deviceToken;

    return MessageDispatch.get().login(
      "loginNOKUserUserWithEmailAndPassword",
      usage,
      { email: email, password: password, deviceToken: deviceToken }
    );
  }
  public async loginAdministratorUserWithEmailAndPassword(
    usage: number,
    d3eParams?: Partial<{
      email: string;
      password: string;
      deviceToken: string;
    }>
  ): Promise<LoginResult> {
    let email = d3eParams?.email;

    let password = d3eParams?.password;

    let deviceToken = d3eParams?.deviceToken;

    return MessageDispatch.get().login(
      "loginAdministratorUserWithEmailAndPassword",
      usage,
      { email: email, password: password, deviceToken: deviceToken }
    );
  }
  public async loginWithOTP(
    usage: number,
    d3eParams?: Partial<{ token: string; code: string; deviceToken: string }>
  ): Promise<LoginResult> {
    let token = d3eParams?.token;

    let code = d3eParams?.code;

    let deviceToken = d3eParams?.deviceToken;

    return MessageDispatch.get().login("loginWithOTP", usage, {
      token: token,
      code: code,
      deviceToken: deviceToken,
    });
  }
  public async getActivityTrackers(
    usage: number,
    request: ActivityTrackersRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<ActivityTrackers> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery(
      "ActivityTrackers",
      usage,
      true,
      request
    );
  }
  public async getAdminLists(
    usage: number,
    request: AdminListsRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<AdminLists> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("AdminLists", usage, true, request, {
      synchronize: synchronize,
    });
  }
  public async getHosiptalList(
    usage: number,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<HosiptalList> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("HosiptalList", usage, false, null, {
      synchronize: synchronize,
    });
  }
  public async getHospitals(
    usage: number,
    request: HospitalsRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<Hospitals> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("Hospitals", usage, true, request, {
      synchronize: synchronize,
    });
  }
  public async getInvoices(
    usage: number,
    request: InvoicesRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<Invoices> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("Invoices", usage, true, request, {
      synchronize: synchronize,
    });
  }
  public async getNotifications(
    usage: number,
    request: NotificationsRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<Notifications> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery(
      "Notifications",
      usage,
      true,
      request,
      { synchronize: synchronize }
    );
  }
  public async getRequestsByInvoice(
    usage: number,
    request: RequestsByInvoiceRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<RequestsByInvoice> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery(
      "RequestsByInvoice",
      usage,
      true,
      request,
      { synchronize: synchronize }
    );
  }
  public async getSearchRequests(
    usage: number,
    request: SearchRequestsRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<SearchRequests> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery(
      "SearchRequests",
      usage,
      true,
      request,
      { synchronize: synchronize }
    );
  }
  public async getUsersList(
    usage: number,
    request: UsersListRequest,
    d3eParams?: Partial<{ synchronize: boolean }>
  ): Promise<UsersList> {
    let synchronize = d3eParams?.synchronize;

    return MessageDispatch.get().dataQuery("UsersList", usage, true, request, {
      synchronize: synchronize,
    });
  }
}
